import SMFindAgreementNumber from '../../containers/FindAgreementNumber'
export const FindAgreementNumberScreen: React.FC = () => {
    // ======================= VIEWS
    return (
        <>
            <SMFindAgreementNumber />
        </>
    )
}

// ======================= EXPORT
export default FindAgreementNumberScreen
